import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIdentity } from './IdentityContext';
import { GOLD, GOLD_LT, CREAM, INK } from '../theme';

const inputStyle = { width: '100%', background: 'transparent', border: 'none', borderBottom: '1px solid rgba(201,162,75,.35)', color: CREAM, fontFamily: "'Cormorant Garamond', serif", fontSize: 18, padding: '12px 34px 12px 2px', boxSizing: 'border-box' };
const labelStyle = { display: 'block', fontSize: 12, letterSpacing: '.2em', textTransform: 'uppercase', color: GOLD, marginBottom: 10 };

function EyeIcon({ off }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {off ? (
        <>
          <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.8 21.8 0 0 1 5.06-6.06M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a21.77 21.77 0 0 1-2.16 3.19" />
          <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
          <line x1="1" y1="1" x2="23" y2="23" />
        </>
      ) : (
        <>
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </>
      )}
    </svg>
  );
}

export default function AdminLogin() {
  const { user, initializing, loginWithPassword } = useIdentity();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!initializing && user) navigate('/admin', { replace: true });
  }, [initializing, user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setSubmitting(true);
    setError(null);
    try {
      await loginWithPassword(email, password);
      // Success updates `user` in context; the effect above redirects.
    } catch (err) {
      setError(err.message || 'Login failed.');
      setSubmitting(false);
    }
  };

  return (
    <div style={{ fontFamily: "'Cormorant Garamond', serif", background: INK, color: CREAM, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: 340, textAlign: 'center' }}>
        <div style={{ fontWeight: 600, fontSize: 14, letterSpacing: '.36em', textTransform: 'uppercase', color: GOLD, marginBottom: 8 }}>IJ Couture</div>
        <h1 style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: 'italic', fontWeight: 500, fontSize: 'clamp(32px,4vw,46px)', margin: '0 0 32px' }}>Admin</h1>

        <div style={{ marginBottom: 20, textAlign: 'left' }}>
          <label style={labelStyle}>Email</label>
          <input type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} required />
        </div>

        <div style={{ marginBottom: 24, textAlign: 'left' }}>
          <label style={labelStyle}>Password</label>
          <div style={{ position: 'relative' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={inputStyle}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              style={{ position: 'absolute', right: 2, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: GOLD_LT, cursor: 'pointer', padding: 4, display: 'flex' }}
            >
              <EyeIcon off={showPassword} />
            </button>
          </div>
        </div>

        {error && <p style={{ color: '#e08a8a', fontSize: 14, marginBottom: 16 }}>{error}</p>}

        <button
          type="submit"
          disabled={submitting}
          style={{ width: '100%', fontWeight: 600, fontSize: 13, letterSpacing: '.2em', textTransform: 'uppercase', padding: '16px 0', background: GOLD, color: INK, border: 'none', cursor: submitting ? 'default' : 'pointer', opacity: submitting ? .6 : 1 }}
        >
          {submitting ? 'Logging in…' : 'Log in'}
        </button>

        <p style={{ fontSize: 14, color: 'rgba(239,228,210,.55)', marginTop: 24 }}>
          Access is invite-only. If you haven't received an invite, contact whoever set up this site.
        </p>
      </form>
    </div>
  );
}
